module.exports = __webpack_public_path__ + "img/1509300844.2975531b.jpg";